<h2 class="mb-4">Your active registration forms</h2>
<table id="dt-my-forms" datatable class="table row-bordered table-hover" [dtOptions]="dataTableOptions">
</table>